module.exports = __webpack_public_path__ + "static/why-we-sleep-f535d09e22ea7f0cd85614609b80a474.jpg";